var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "80px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "区域名称", prop: "areaName" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.childData.areaName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "areaName", $$v)
                          },
                          expression: "childData.areaName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "100%" },
                        attrs: {
                          maxlength: "200",
                          "show-word-limit": "",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 2 }
                        },
                        model: {
                          value: _vm.childData.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "remark", $$v)
                          },
                          expression: "childData.remark"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }